import { TableBody, TableCell, TableHead, TableRow } from "@mui/material"

// others
import { Referral_Sources_Headers } from "../../constants"
import { ReferralSourcesListingProps } from "../../interfaceTypes/props"

// components
import ReferralSource from "../menus/ReferralSource"
import { StickyTable } from "../common/StickyTable"
import { TableSkeleton } from "../skeletons/TableSkeleton"
import { CustomTableCell } from "../common/CustomTableCell"
import { CustomPagination } from "../common/CustomPagination"

const ReferralSourcesListing = ({ referralSources, loading, refetch }: ReferralSourcesListingProps) => {
  return (
    <StickyTable pagination={<CustomPagination loading={loading} />} height="370px">
      <TableHead>
        <TableRow hover>
          {Referral_Sources_Headers.map((columnName, index) => 
            <TableCell 
              key={index} 
              component="th" 
              align={'left'} 
              width={index === Referral_Sources_Headers.length - 1 ? '100px' : 'auto'} 
            >
              {columnName}
            </TableCell>
          )}
        </TableRow>
      </TableHead>
          
      { loading ?         
          <TableSkeleton noOfRows={7} noOfCols={Referral_Sources_Headers.length} />
        : 
          <TableBody>
            {referralSources?.map((source) => {
              const { id, sourceType } = source || {}

              return (
                <TableRow key={id} hover>
                  <CustomTableCell value={sourceType} maxWidth="376px" />

                  <TableCell>
                    <ReferralSource referralSource={source} refetch={refetch} />
                  </TableCell>
                </TableRow>
              )
            })}     
        </TableBody>     
      } 
    </StickyTable>
  )
}

export default ReferralSourcesListing